// @flow
import Component from './main'

export default () => ({
  path: 'files/view',
  element: <Component />,
})
